module.exports = __webpack_public_path__ + "img/american_express.30cdef4.svg";